var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemAddCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#222324",
  fillRule: "evenodd",
  d: "M18 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 2H6v12h12zm-1.21 2.71c.28.279.28.73 0 1.01l-5.714 5.714a.71.71 0 0 1-1.01 0L7.21 12.576a.713.713 0 1 1 1.01-1.01l2.352 2.353 5.21-5.21c.279-.279.73-.279 1.01 0"
})));
export default SvgGemAddCheckbox;